import { render, staticRenderFns } from "./BusinessUnits.vue?vue&type=template&id=c697c668&"
import script from "./BusinessUnits.vue?vue&type=script&lang=js&"
export * from "./BusinessUnits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports